import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { fetchPlacements } from 'core/actions/ocapi';

import ContentWrap from 'core/modules/Partials/ContentWrap/ContentWrap';
import { selectIsMobileMQ } from 'core/modules/MediaQueries/selectors';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import InfoBarAccordion from './components/InfoBarAccordion/InfoBarAccordion';
import InfoBarSlider from './components/InfoBarSlider/InfoBarSlider';

import { triggerInfoBarIsViewed } from './actions';

import {
  selectInfoBarIsLoading,
  selectInfoBarIsLoaded,
  selectInfoBarOffers,
  selectDealOfTheWeek,
  selectSalesInfoBar,
  selectInfoBarConfig,
} from './selectors';

import './InfoBar.scss';

function InfoBar({ isPersonalizedMhp }) {
  const dispatch = useDispatch();

  const isLoading = useSelector(selectInfoBarIsLoading);
  const isLoaded = useSelector(selectInfoBarIsLoaded);
  const offers = useSelector(selectInfoBarOffers);
  const dealOfTheWeek = useSelector(selectDealOfTheWeek);
  const salesInfoBar = useSelector(selectSalesInfoBar);
  const config = useSelector(selectInfoBarConfig);
  const isMobileMQ = useSelector(selectIsMobileMQ);

  const { api: { params: dealOfTheWeekParams, options: dealOfTheWeekOptions } } = dealOfTheWeek.config;
  const { api: { params: salesInfoBarParams, options: salesInfoBarOptions } } = salesInfoBar.config;
  const { shouldUseSliderView, carousel, useAddToFavorite } = config;

  useEffect(() => {
    if (!isLoaded && !isLoading) {
      dispatch(fetchPlacements(dealOfTheWeekParams, dealOfTheWeekOptions));
      dispatch(fetchPlacements(salesInfoBarParams, salesInfoBarOptions));
    }
  }, []);

  useEffect(() => {
    if (isLoaded && offers.length) {
      offers.forEach(offer => dispatch(triggerInfoBarIsViewed(offer)));
    }
  }, [isLoaded, offers.length]);

  // Render section when both Deal Of The Week and Sales InfoBar offers are loaded
  if (!isLoaded || isEmpty(offers)) {
    return null;
  }

  return (
    <div className="mn_infoBar mn_clearfix" data-test="info-bar">
      <ContentWrap mobile tablet l xl xxl={!isPersonalizedMhp}>
        { shouldUseSliderView && isMobileMQ ?
          <InfoBarSlider
            useAddToFavorite={useAddToFavorite}
            carousel={carousel}
            offers={offers}
            config={config}
          />
          :
          <InfoBarAccordion
            offers={offers}
            config={config}
          />
        }
      </ContentWrap>
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><InfoBar {...props} /></ComponentErrorBoundary>;
